import { Navigate, useLocation } from "react-router-dom"
import { resolveAnalyticsRedirect } from "@/lib/routing/analyticsTabs"

/**
 * Route element for a retired analytics tab slug (`locations`, `llm-referrals`,
 * `forms`, `bots`): replaces the URL with the tab that now holds the content,
 * keeping the date range and filters in the query string.
 */
export function AnalyticsRedirect() {
  const location = useLocation()
  const target = resolveAnalyticsRedirect(location.pathname, location.search)
  if (!target) return <Navigate to=".." replace />
  return <Navigate to={{ pathname: target.pathname, search: target.search, hash: location.hash }} replace />
}

export default AnalyticsRedirect
